/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { cardTransactionScreens } from '../../constants';
import CardTransactionDetails from './details';
import InfoPopup from '../../../shared/Modals/InfoPopup';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

const CardTransactionDetailsModal = ({ details, hide }) => {
  const [currentScreen, setCurrentScreen] = useState(cardTransactionScreens.DETAILS);

  const { t: translate } = useTranslation();
  const [featurePayoutMonthlyCashbackRewardsAutomatically] = useSetting(
    'app_features',
    'feature_payout_monthly_cashback_rewards_automatically'
  );

  const { isUsEnv } = useUsEnv();

  const infoPopupOptions = {
    title: translate(isUsEnv ? 'promo_us_body2' : 'promo_body2'),
    content: () => (
      <p className="text-white text-f6 mt-2">
        {featurePayoutMonthlyCashbackRewardsAutomatically
          ? translate(
              isUsEnv
                ? 'transaction_cashback_popup_info_us_note'
                : 'transaction_cashback_popup_info_note'
            )
          : translate(
              isUsEnv
                ? 'transaction_manually_cashback_popup_info_us_note'
                : 'transaction_manually_cashback_popup_info_note'
            )}
      </p>
    ),
    mainScreen: cardTransactionScreens.DETAILS,
    withBack: true,
    isButtonInFooter: false,
    isScrollable: false,
  };

  const cardTransactionDetailsFLow = useMemo(
    () => [
      {
        screen: cardTransactionScreens.DETAILS,
        component: (
          <CardTransactionDetails
            hidePopup={hide}
            details={details}
            openScreen={setCurrentScreen}
          />
        ),
      },
      {
        screen: cardTransactionScreens.CASHBACK_INFO,
        component: <InfoPopup options={infoPopupOptions} openScreen={setCurrentScreen} />,
      },
    ],
    [hide, details]
  );

  const SelectedComponent = useMemo(
    () => cardTransactionDetailsFLow.find((item) => item.screen === currentScreen).component,
    [cardTransactionDetailsFLow, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

CardTransactionDetailsModal.propTypes = {
  hide: PropTypes.func,
  details: PropTypes.object.isRequired,
};

export default CardTransactionDetailsModal;
